import styled from 'styled-components';
import { SIDE } from '@/components/views/Resolution886/enums';

interface ShadowBarProps {
	side: 'left' | 'right';
}

export const ShadowBar = styled.div<ShadowBarProps>`
	width: 5px;
	height: 35px;
	box-shadow: ${({ side }) =>
		side === SIDE.LEFT ? '3px 0px 3px rgba(0, 0, 0, 0.06)' : '-3px 0px 3px rgba(0, 0, 0, 0.06)'};
`;
